module.exports = __webpack_public_path__ + "img/139.4c478017.jpg";